import React from 'react';
import { BookmarkIcon, DownloadIcon } from 'lucide-react';
interface AlgaCoffeeTranscriptWidgetProps {
  coffeeHost: string;
  coffeeTitle: string;
}
const AlgaCoffeeTranscriptWidget: React.FC<AlgaCoffeeTranscriptWidgetProps> = ({
  coffeeHost,
  coffeeTitle
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-464">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-465">
        <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-466">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-467" />
        </div>
        <div data-id="element-468">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-469">
            Trascrizione completa
          </h2>
          <p className="text-xs text-gray-500" data-id="element-470">Powered by EIIS Intelligence</p>
        </div>
      </div>
      <div className="p-4" data-id="element-471">
        <div className="space-y-4" data-id="element-472">
          <div className="flex items-center justify-between" data-id="element-473">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-474">
              Conversazione registrata
            </h4>
            <div className="flex items-center space-x-2" data-id="element-475">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-476">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-477" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-478">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-479" />
              </button>
            </div>
          </div>
          <div className="text-sm text-gray-600 max-h-60 overflow-y-auto border border-gray-200 rounded-lg p-3" data-id="element-480">
            <div className="space-y-3" data-id="element-481">
              <div data-id="element-482">
                <p className="font-medium" data-id="element-483">{coffeeHost} (14:02):</p>
                <p data-id="element-484">
                  Buongiorno a tutti e benvenuti a questo EIIS Coffee su{' '}
                  {coffeeTitle}. Sono molto felice di vedere così tanti
                  partecipanti interessati a questo argomento.
                </p>
              </div>
              <div data-id="element-485">
                <p className="font-medium" data-id="element-486">Edoardo Gatner (14:05):</p>
                <p data-id="element-487">
                  Grazie per l'organizzazione di questo evento. Vorrei sapere
                  quali sono secondo te le sfide principali nell'implementazione
                  di strategie ESG in aziende di medie dimensioni?
                </p>
              </div>
              <div data-id="element-488">
                <p className="font-medium" data-id="element-489">{coffeeHost} (14:07):</p>
                <p data-id="element-490">
                  Ottima domanda Edoardo. Le aziende di medie dimensioni spesso
                  affrontano sfide specifiche come risorse limitate, competenze
                  interne insufficienti e difficoltà nel misurare l'impatto
                  delle iniziative ESG...
                </p>
              </div>
              <div data-id="element-491">
                <p className="font-medium" data-id="element-492">Laura Bianchi (14:12):</p>
                <p data-id="element-493">
                  Dal mio punto di vista, un'altra sfida importante è
                  l'integrazione delle strategie ESG con gli obiettivi di
                  business esistenti. Spesso vengono visti come due percorsi
                  separati.
                </p>
              </div>
              <div data-id="element-494">
                <p className="font-medium" data-id="element-495">{coffeeHost} (14:15):</p>
                <p data-id="element-496">
                  Assolutamente d'accordo Laura. L'integrazione è fondamentale
                  per il successo a lungo termine...
                </p>
              </div>
            </div>
          </div>
          <div className="text-center text-xs text-gray-500" data-id="element-497">
            <a href="#" className="text-custom-green hover:underline" data-id="element-498">
              Visualizza trascrizione completa
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeTranscriptWidget;